import { Injectable } from '@angular/core';
import { ProcoreUserConfig } from '../models/procoreUserConfig';

@Injectable({
	providedIn: 'root'
})
export class ContextService {
	procoreIsSandbox;
	// this.contextService.procoreIsSandbox = true or false

	procoreAuthCode;
	// this.contextService.procoreAuthCode = "12345"

	procoreUserConfig: ProcoreUserConfig;
	// this.contextService.procoreUserConfig.procoreUserId
	// this.contextService.procoreUserConfig.dropboxSignDefaultSubject
	// this.contextService.procoreUserConfig.dropboxSignDefaultMessage
	// this.contextService.procoreUserConfig.dropboxSignDefaultCC

	procoreUserInfo: any;
	// this.contextService.procoreUserInfo.email = "brad.hickey@shakeit.ai"
	// this.contextService.procoreUserInfo.name = "Brad Hickey"
	// this.contextService.procoreUserInfo.procoreUserId = "12345"
	// this.contextService.procoreUserInfo.isAdmin = true or false
	// this.contextService.procoreUserInfo.companyName = "Shake IT"

	procoreContextObject: any;
	// this.contextService.procoreContextObject.context.company_id = "4265852"
	// this.contextService.procoreContextObject.context.id = "19111"
	// this.contextService.procoreContextObject.context.object_id = "19111"
	// this.contextService.procoreContextObject.context.procore_api_base_url = "https://sandbox.procore.com"
	// this.contextService.procoreContextObject.context.project_id = "120637"
	// this.contextService.procoreContextObject.context.route = "/:project_id/project/prime_contracts/:prime_contract_id/change_orders/potential_change_orders/:id"
	// this.contextService.procoreContextObject.context.view = "prime_contracts.change_orders.detail"
	// this.contextService.procoreContextObject.context.generatedFileUrl = "https://sandbox.procore.com/rest/v1.0/companies/4265852/invoices/async_jobs/5ecedcf1-ea08-43a8-9dfa-307ff0a32b9c"
	// this.contextService.procoreContextObject.context.generatedFileType = "coversheet" or "pdf"

	client: any; // This is only set when the customer signs up.  After that it is never set
	// this.contextService.client.clientId
	// this.contextService.client.clientName
	// this.contextService.client.stripeCustomerId
	// this.contextService.client.isActive

	clientDetailProcore: any;
	// this.contextService.clientDetailProcore.clientId = "12345"
	// this.contextService.clientDetailProcore.applicationEnabled = true or false
	// this.contextService.clientDetailProcore.companyId = "12345"
	// this.contextService.clientDetailProcore.procoreDomain
	// this.contextService.clientDetailProcore.licenseExpirationDate
	// this.contextService.clientDetailProcore.renewalType = "auto" or "manual"
	// this.contextService.clientDetailProcore.isTrial = true or false
	// this.contextService.clientDetailProcore.dropboxSignDefaultSubject
	// this.contextService.clientDetailProcore.dropboxSignDefaultMessage
	// this.contextService.clientDetailProcore.dropboxSignDefaultCC
	// this.contextService.clientDetailProcore.setExecutedAfterCompleted = true or false
	// this.contextService.clientDetailProcore.purchaseOrderStatusAfterRequested
	// this.contextService.clientDetailProcore.purchaseOrderStatusAfterCompleted
	// this.contextService.clientDetailProcore.subContractStatusAfterRequested
	// this.contextService.clientDetailProcore.subContractStatusAfterCompleted
	// this.contextService.clientDetailProcore.primeContractStatusAfterRequested
	// this.contextService.clientDetailProcore.primeContractStatusAfterCompleted
	// this.contextService.clientDetailProcore.enableMultipleAttachments = true or false
	// this.contextService.clientDetailProcore.selectAllAttachments = true or false
	// this.contextService.clientDetailProcore.enableDropboxSignTemplates = true or false
	// this.contextService.clientDetailProcore.allowDeclineRequest = true or false
	// this.contextService.clientDetailProcore.declineRequestDefault = true or false
	// this.contextService.clientDetailProcore.allowSignerReassignment = true or false
	// this.contextService.clientDetailProcore.requestorEmailType
	// this.contextService.clientDetailProcore.customRequestorEmail
	// this.contextService.clientDetailProcore.allowExpirationDate = true or false
	// this.contextService.clientDetailProcore.adobeAccountType
	// this.contextService.clientDetailProcore.adobeApplicationId
	// this.contextService.clientDetailProcore.adobeApplicationClientSecret
	// this.contextService.clientDetailProcore.adobeTestMode = true or false
	// this.contextService.clientDetailProcore.dropboxSignAccountType = OAUTH or OAUTHG or API
	// this.contextService.clientDetailProcore.dropboxSignTestMode = true or false
	// this.contextService.clientDetailProcore.anyUserCanCancel = true or false
	// this.contextService.clientDetailProcore.anyUserCanSendReminder = true or false
	// this.contextService.clientDetailProcore.anyUserCanDownload = true or false
	// this.contextService.clientDetailProcore.nonUsersCanViewStatus = true or false
	// this.contextService.clientDetailProcore.usersExist = true or false
	// this.contextService.clientDetailProcore.addContractSigner = true or false
	// this.contextService.clientDetailProcore.addContractSignerRole
	// this.contextService.clientDetailProcore.primeContractFilenameMarkSigned = true or false
	// this.contextService.clientDetailProcore.primeContractFilename1
	// this.contextService.clientDetailProcore.primeContractFilename2
	// this.contextService.clientDetailProcore.primeContractFilename3
	// this.contextService.clientDetailProcore.commitmentFilenameMarkSigned = true or false
	// this.contextService.clientDetailProcore.commitmentFilename1
	// this.contextService.clientDetailProcore.commitmentFilename2
	// this.contextService.clientDetailProcore.commitmentFilename3
	// this.contextService.clientDetailProcore.changeOrderFilenameMarkSigned = true or false
	// this.contextService.clientDetailProcore.changeOrderFilename1
	// this.contextService.clientDetailProcore.changeOrderFilename2
	// this.contextService.clientDetailProcore.changeOrderFilename3
	// this.contextService.clientDetailProcore.enableDropboxSignTemplateOverlays = true or false
	// this.contextService.clientDetailProcore.enableDropboxSignTemplateOverlayFields = true or false
	// this.contextService.clientDetailProcore.enableDropboxSignTemplateOverlayCCs = true or false
	// this.contextService.clientDetailProcore.enableDropboxSignTemplateOverlayMessage = true or false
	// this.contextService.clientDetailProcore.defaultRequestTemplateCommitmentPurchaseOrder
	// this.contextService.clientDetailProcore.defaultRequestTemplateCommitmentSubcontract
	// this.contextService.clientDetailProcore.defaultRequestTemplatePrimeContract

	stripeCustomerId: string;
	// this.contextService.stripeCustomerId = "12345"

	signatureCount: any;
	// this.contextService.signatureCount.signatures.total
	// this.contextService.signatureCount.signatures.used
	// this.contextService.signatureCount.dropboxSignUsername
	// this.contextService.signatureCount.dropboxSignRoleCode = "a" or "r" or "d" or "m"
	// this.contextService.signatureCount.dropboxSignApiKeyExists = true or false
	// this.contextService.signatureCount.currentTermEndDate = "2026-03-07 23:59:59.0"
	// this.contextService.signatureCount.lastInvoicePaid = true or false
	// this.contextService.signatureCount.stripeCustomerExists = true or false

	quotes = [];
	// this.contextService.quotes.amountTotal = 142500
	// this.contextService.quotes.billingType = "year"
	// this.contextService.quotes.created = 1768537097
	// this.contextService.quotes.expiresAt = Date Sat Feb 14 2026 23: 18: 17 GMT-0500(Eastern Standard Time)
	// this.contextService.quotes.id = "qt_1Sq4UH2mt4nrLvL5nPso4AWx"
	// this.contextService.quotes.status = "open" or "accepted"
	// this.contextService.quotes.subscriptionType = "connector"
	// this.contextService.quotes.usageType = "request"
	// this.contextService.quotes.volume = "1200"

	subscription;
	// this.contextService.subscription.amountTotal = 142500
	// this.contextService.subscription.billingType = "year"
	// this.contextService.subscription.created = 1768537097
	// this.contextService.subscription.expiresAt = Date Sat Feb 14 2026 23: 18: 17 GMT-0500(Eastern Standard Time)
	// this.contextService.subscription.id = "qt_1Sq4UH2mt4nrLvL5nPso4AWx"
	// this.contextService.subscription.status = "past_due" or "?" or "paid"
	// this.contextService.subscription.subscriptionType = "connector"
	// this.contextService.subscription.usageType = "request"
	// this.contextService.subscription.volume = "1200"

	isRfi;
	// this.contextService.isRfi = true or false

	constructor() { }
}
